<H1>MEASUREMENT SLOT</H1>

<p>
  This is a view based on all the assigned measurements in the I/O Mapper.
  So as requested by the climate. This a view of all user SLOTS. Where a slot has one measurement
</p>

<table>
<tr *ngFor='let in of counter(100) ;let i = index'>

      <app-measurement-details [slotNumber] = "i" ></app-measurement-details>

</tr>
</table>



